import i18n from 'services/base/i18n';

export default {
  // The title text of the login page
  login: () => i18n.pgettext('Pages|Login', 'Login'),

  // Label for the email address input
  email: () => i18n.pgettext('Pages|Login', 'EMAIL ADDRESS'),

  // Label for the password input
  password: () => i18n.pgettext('Pages|Login', 'PASSWORD'),

  // Link to the forgot password page
  forgotPassword: () => i18n.pgettext('Pages|Login', 'FORGOT PASSWORD?'),

  // Label for the submit button on the login form
  buttonLogin: () => i18n.pgettext('Pages|Login', 'LOGIN'),
};
